// What the Author may hand the upload panel. The check runs in the browser so
// a PDF is refused without a request (DESIGN "Upload a Source"); the server
// answers 415 for the same file renamed to .docx, which is the case this
// cannot catch and must not pretend to.
import type { ErrorCode } from "@contract";

export const ACCEPTED_EXTENSIONS = [".docx", ".epub", ".md", ".markdown"] as const;
/** The `accept` attribute of the file input and the drop zone. */
export const ACCEPT_ATTRIBUTE = ACCEPTED_EXTENSIONS.join(",");
/** POST /books rejects a larger multipart body with 413 (plan: at most 32 MB). */
export const MAX_SOURCE_BYTES = 32 * 1024 * 1024;

/**
 * The error code this file would earn, or null when it is worth sending.
 * Extension only: a renamed PDF passes here and the server's magic-byte sniff
 * refuses it with PDF_NOT_SUPPORTED, which is the path the screen also shows.
 */
export function sourceRejection(file: { name: string; size: number }): ErrorCode | null {
  const name = file.name.toLowerCase();
  if (name.endsWith(".pdf")) return "PDF_NOT_SUPPORTED";
  if (!ACCEPTED_EXTENSIONS.some((extension) => name.endsWith(extension))) {
    return "UNSUPPORTED_FORMAT";
  }
  if (file.size > MAX_SOURCE_BYTES) return "PAYLOAD_TOO_LARGE";
  return null;
}
